import vectorSearchRouterPaths from './vectorSearchRouterPaths';

export default vectorSearchRouterPaths;
